export const ActivityAction = {
  APPLICATION_DETAILS_SETTINGS: "APPLICATION_DETAILS_SETTINGS",
}

export async function startActivityAsync() {}

export default { ActivityAction, startActivityAsync }
